import * as React from 'react';
import Common from './Order/Common';
import useReduxState from "../hooks/useReduxState";
import { useSearchParams } from "react-router-dom";
import useCheckAuthPermissions from 'src/hooks/component/useCheckAuthPermissions';

export function Order() {
    const [searchParams] = useSearchParams();
    const [Order__Component__Loader] = useReduxState(searchParams.get(Common.param_key) ? searchParams.get(Common.param_key) : Common.default_component.param_value, Common.redux_key);
    const [_check_p] = useCheckAuthPermissions();

    return (
        <>
            <div className="logged-screen">
                {
                    (_check_p('ORDER_HISTORY').status === true) &&
                    <div className="">
                        {React.createElement(Common.chain[Order__Component__Loader].element)}
                    </div>
                }
            </div>
        </>
    );
}